
<div class="library-container">
  <!-- LEFT SIDEBAR -->
  <aside class="left-panel">
    <div class="sidebar">
      <h3 class="sidebar-title">Library Support</h3>

      <div class="sidebar-scroll">
      <ul class="sidebar-list">
        <li (click)="go('productlibrary')" [class.active]="activeTab==='productlibrary'">Product Library</li>
        <li (click)="go('studylibrary')" [class.active]="activeTab==='studylibrary'">Study Library</li>
        <li (click)="go('ime-library')" [class.active]="activeTab==='ime-library'">IME Library</li>
        <li (click)="go('dme-library')" [class.active]="activeTab==='dme-library'">DME Library</li>
        <li (click)="go('roa-library')" [class.active]="activeTab==='roa-library'">ROA Library</li>
        <li (click)="go('codelist-library')" [class.active]="activeTab==='codelist-library'">Code List Library</li>
      </ul>
      </div>
    </div>
  </aside>

  <!-- RIGHT CONTENT -->
  <main class="right-panel">
    <section class="content-area">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>

